import { __assign, __extends, __rest } from "tslib";
import Highlighter from 'react-highlight-words';
import React, { PureComponent } from 'react';
var EkbHighLighter = (function (_super) {
    __extends(EkbHighLighter, _super);
    function EkbHighLighter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EkbHighLighter.prototype.render = function () {
        var _a = this.props, highlightClassName = _a.highlightClassName, searchWords = _a.searchWords, textToHighlight = _a.textToHighlight, others = __rest(_a, ["highlightClassName", "searchWords", "textToHighlight"]);
        var str = searchWords[0];
        if (str) {
            str = str.replace(/\\/g, '\\\\');
            var strSpecial = ['+', '?', '|', '^', '~', '(', ')', '*', '&', '^', '$', '"', '（', '）'];
            strSpecial.forEach(function (s) {
                var reg = new RegExp('\\' + s, 'gim');
                var l = '\\' + s;
                str = str.replace(reg, l);
            });
        }
        return (React.createElement(Highlighter, __assign({}, others, { autoEscape: true, highlightClassName: highlightClassName, searchWords: [str], textToHighlight: textToHighlight || '' })));
    };
    return EkbHighLighter;
}(PureComponent));
export default EkbHighLighter;
